import { createContext } from "react";
import { labels } from "../../interfaces";

export interface ContextProps {
  labelLanguage: { [key: string]: string };
  language: string;

  setLabelLanguages: (language: string, labels: labels[]) => void;
  getLabelLanguage: (key: string, defaultValue?: string) => string;
}

export const LanguageContext = createContext({} as ContextProps);
